import React from 'react';
import classNames from 'classnames';

import {
  SbatGroupInstructors,
  SbatGroupSuperBatches,
} from 'features/classCreation';
import DateTimeInput from 'components/DateTimeInput';
import RescheduleSbatGroupLock from '../RescheduleSbatGroupLock';
import styles from './RescheduleClassRow.module.scss';
import TableCell from 'components/TableCell';
import TableRow from 'components/TableRow';

function RescheduleClassRow({ sbatGroup }) {
  return (
    <TableRow className={classNames({ [styles.locked]: sbatGroup.locked })}>
      <TableCell>{sbatGroup.academy_topic.title}</TableCell>
      <TableCell>
        <SbatGroupSuperBatches
          trimIfMany
          sbatGroup={sbatGroup}
        />
      </TableCell>
      <TableCell>
        <SbatGroupInstructors sbatGroup={sbatGroup} />
      </TableCell>
      <TableCell>{sbatGroup.academy_topic.academy_module.name}</TableCell>
      <TableCell>
        <DateTimeInput
          compact
          disabled
          value={new Date(sbatGroup.date_of_topic).getTime()}
          vertical
        />
      </TableCell>
      <TableCell className={styles.lock}>
        <RescheduleSbatGroupLock sbatGroup={sbatGroup} />
      </TableCell>
    </TableRow>
  );
}

export default RescheduleClassRow;
